import { CustomButton } from "./sections/Buttons";
import { Link } from "react-router-dom";

const OccupationalTherapyPage = () => (
  <div className="bg-white">
    {/* Hero Section */}
    <section className="bg-teal-500 relative overflow-hidden py-20 text-center">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <svg
          width="900"
          height="400"
          viewBox="0 0 900 400"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-full opacity-20"
        >
          <circle cx="450" cy="200" r="200" fill="#fff" fillOpacity="0.07" />
          <circle cx="450" cy="200" r="300" fill="#fff" fillOpacity="0.04" />
        </svg>
      </div>
      <div className="relative z-10">
        <h1 className="text-5xl font-extrabold mb-2 text-white drop-shadow">
          Occupational
          <br />
          Therapy
        </h1>
        <div className="text-2xl text-white font-semibold mb-4">
          At Spectrum Nurturing Academy
        </div>
      </div>
    </section>

    {/* Info Card Section */}
    <section className="relative py-16 flex justify-center items-center bg-white">
      {/* Decorative shapes */}
      <div className="hidden md:block absolute left-0 top-0 w-1/3 h-64 -z-10">
        <svg viewBox="0 0 200 200" className="w-full h-full">
          <polygon points="0,0 200,0 0,200" fill="#4F46E5" opacity="0.7" />
        </svg>
      </div>
      <div className="hidden md:block absolute right-0 bottom-0 w-1/5 h-40 -z-10">
        <svg viewBox="0 0 100 100" className="w-full h-full">
          <circle cx="80" cy="80" r="30" fill="#FBBF24" opacity="0.8" />
        </svg>
      </div>
      <div className="max-w-xl w-full bg-white rounded-xl shadow-2xl p-8 z-10">

        <p className="text-gray-800 text-base mb-4">
          Our Occupational Therapy program helps children develop the skills needed for daily life and school participation. OT focuses on:</p>

        <ul className="list-disc pl-6 text-gray-800 text-base space-y-3 mb-4">
          
  <li>Fine motor skills like writing, cutting, and grasping.</li>
  <li>Sensory integration for children with over- or under-sensitivities.</li>
  <li>Self-help skills such as dressing, eating, and grooming.</li>
  <li>Visual-motor and perceptual skills.</li>
  <li>Attention, focus, and regulation strategies.</li>


        </ul>


        <p className="text-gray-800 text-base mb-0">We use fun, engaging, play-based activities that encourage independence and self-confidence.</p>


        {/* <div className="text-gray-700 text-sm flex flex-col gap-1">
          <span className="inline-flex items-center gap-1">
            <span role="img" aria-label="funding">
              🏛️
            </span>{" "}
            Regional Center funding available for children 18mos-36months
          </span>
          <span className="inline-flex items-center gap-1">
            <span role="img" aria-label="insurance">
              🏥
            </span>{" "}
            Kaiser Insurance accepted
          </span>
        </div> */}
      </div>
    </section>

    {/* CTA Section */}
    <section className="flex justify-center items-center py-20 px-2 bg-white">
      <div className="w-full max-w-3xl mx-auto rounded-2xl shadow-xl bg-gradient-to-r from-teal-400 to-yellow-400 p-12 text-center">
        <h2 className="text-3xl font-extrabold text-white mb-4">
          Come Visit Us
        </h2>
        <p className="text-white mb-8 text-lg font-medium">
          Contact us today to schedule a free evaluation and tour. Our dedicated
          team is ready to help your child succeed.
        </p>
        <div className="flex justify-center mt-6">
          <Link to="/contact">
          <CustomButton
            label="CONTACT US"
            colorClass="text-white bg-gradient-to-r from-teal-400 to-yellow-400"
          />
        </Link>
        </div>
      </div>
    </section>
  </div>
);

export default OccupationalTherapyPage;
